import { render, staticRenderFns } from "./actionLogs.vue?vue&type=template&id=6af0b2a8&"
import script from "./actionLogs.vue?vue&type=script&lang=js&"
export * from "./actionLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports